import React from 'react'
import '../App.css'
import { useState } from 'react'
import {auth, provider} from '../config/firebase'
import {signInWithPopup,signInWithEmailAndPassword} from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setemail] = useState("")
  const [password, setpassword] = useState("")

  const signinwithGoogle = async () =>{
   const result= await signInWithPopup(auth, provider);
   toast.success("You have Log In Successfully");
   navigate("/")

  }

  const handlelogin = async(e) =>{
    e.preventDefault();
    try{
    await signInWithEmailAndPassword(auth, email, password)
  
    toast.success("You have Log In Successfully");
    navigate("/");
  
}
  catch(error) {
    
    toast.error(error.message)
  };
    
  }
  
  return (
    < div >
    <div  >
    <div className='login-cont'>
      <div className='card'>
        <h2 style={{textAlign:"center"}}>Welcome Back 👋</h2>
        <form className='login-form' onSubmit={handlelogin}>
          <input type='email' value={email} placeholder='Enter Your name' onChange={(e) =>{ setemail(e.target.value)}} className='login-input' required/>
          <input type='password' value={password}   placeholder='Password' onChange={(e) =>{ setpassword(e.target.value)}} className='login-input' required/>
          <Link to='/resetpassword' className='fp-link'>Forgot Password?</Link>
          <div>
          <button className="btn btn-outline-primary" type='submit'>Log In</button>
          </div>
        </form>
        <div className='google-login'>
         <h3 style={{font:"1.6rem", color:"green"}}>OR</h3>
         <p>Login in with Google</p>
         <button onClick={signinwithGoogle}>Login with Google</button>
         </div>
         <span className='alt-links'>Don't have a account? <Link to='/signup'>Sign In</Link></span>
      </div>
    </div>
    </div>
    </div>
  )
}

export default LoginPage